The input parameter for the `deleteUploadedCandidate` mutation.
